import styled from 'styled-components';

import {
  BusinessLogicContainer,
  BusinessLogicSaveButton,
  BLSaveButton,
  RuleEditingContainer,
  TableEditContainer,
} from '../BusinessLogicTab/styles';

export const Container = styled.div`
  color: #ffffff;
  > ul {
    ::-webkit-scrollbar-thumb:window-inactive {
      background: rgb(37, 41, 45);
    }
    ::-webkit-scrollbar {
      width: 8px;
    }
    /* Track */
    ::-webkit-scrollbar-track {
      border-radius: 4px;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      border-radius: 4px;
    }
  }
`;

export const ModalPopupContainer = styled.div`
  .ant-modal-content {
    width: 800px;
    min-height: 35vh;
    background-color: #25292d;
    color: #ffffff;
    .ant-modal-body {
      > div {
        padding: 15px;
        > div.add-edit-label {
          margin-bottom: 40px;
          text-align: center;
          font-weight: bold;
          font-size: 20px;
        }
          > div.section-name{
          display: flex !important;
          flex-direction: row;
          justify-content: space-between !important;
          margin-bottom: 8px;
          }
      }
    }
    .ant-modal-close {
      color: #ffffff;
    }
      
    .ant-input.groupName {
    height: 40px;
    }
    
    .searchSelectWrapper {
      input::placeholder{
        color: #BFBFBF;
        font-size:14px;
      }
    }
  }
`;

export const InsertWrapper = styled.div`
  margin-top: 20px;
  .react-pdf__Document {
    .pageLayout {
      margin: 0px 0px;
      padding: 0px;
      .react-pdf__Thumbnail {
        .react-pdf__Thumbnail__page {
          border-radius: 10px;
          .react-pdf__Thumbnail__page__canvas {
            border-radius: 10px;
          }
        }
      }
    }
  }
  .drag-container {
    display: flex;
    align-items: center;
    column-gap: 20px;
  }
  .pdf-container {
    position: relative;
    transition: transform 0.2s cubic-bezier(0.33, 0.04, 0.63, 0.93) 0s;
    &:hover {
      cursor: pointer;
      transform: scale(1.05) translate(0px, 0px) perspective(500px);
      .dropdown-menu {
        display: flex;
      }
      .preview-button {
        display: flex;
      }
    }
    padding: 5px;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 315px;
    width: 225px;
    background: #fff !important;
    border: none;
    box-shadow:none > img {
      border-radius: 2px;
      width: initial;
      max-height: 100%;
      height: 305px;
      max-width: 100%;
    }
  }

  .template-name {
    font-size: 18px;
    color: #fff;
    padding: 5px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: center;
    text-transform: uppercase;
    font-weight: 600;
    max-width: 210px;
    margin-left: 20px;
    h2 {
      font-family: ambroise-firmin-std, serif;
      color: #fff;
      font-size: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: pre;
      text-align: center;
      max-width: 350px;
    }
  }

  .preview-button {
    background-color: rgba(14, 19, 24, 0.7);
    color: #ffffff;
    width: 22px;
    height: 18px;
    border-radius: 5px;
    display: none;
    align-items: center;
    justify-content: center;
    position: absolute;
    bottom: 5px;
    right: 5px;
    font-size: 14px;
    .anticon {
      color: #fff;
    }
    &:hover {
      background-color: rgb(0 0 0 / 0.5);
    }
  }
`;

export const DropdownDetails = styled.div`
  display: none;
  align-items: center;
  position: absolute;
  right: 5px;
  top: 5px;
  background-color: ${props => (props.vertical ? 'rgb(14 19 24 / 0%)' : 'rgba(14, 19, 24, 0.7)')};
  color: #ffffff;
  padding: 2px;
  width: 20px;
  height: 16px;
  border-radius: 4px;
  &.dropdown-visible {
    position: relative;
    display: flex;
    top: initial;
    right: initial;
    margin-left: auto;
  }
  &:hover {
    background-color: ${props => (props.vertical ? '' : 'rgb(0 0 0 / 0.5)')};
  }
  .anticon-more {
    transform: ${props => (props.vertical ? 'rotate(180deg)' : 'rotate(90deg)')};
  }
  .ant-dropdown {
    top: 20px !important;
    right: 2px !important;
    left: initial !important;
    z-index: 100001;
    .ant-dropdown-menu {
      min-width: 100px;
    }
    .ant-dropdown-menu-item {
      font-weight: bold;
      font-size: 14px;
      padding: 6px 12px;
      margin: 1px 0px;
    }
  }
`;

export const PreviewInsertContainer = styled.div`
  .react-pdf__Document {
    align-items: center;
    .page_preview_pageLayout {
      margin-top: 10px;
      margin-bottom: 10px;
    }
  }
`;

export const BlModalContainer = styled.div``;

export const BusinessLogicSaveButton1 = styled(BusinessLogicSaveButton)`
  div,
  span {
    margin-top: -15px;
    min-height: 35px;
  }
`;

export const BLSaveButton1 = styled(BLSaveButton)`
  div,
`;

export const BusinessLogicContainer1 = styled(BusinessLogicContainer)`
  z-index: 3;
  position: relative;
`;

export const RuleEditingContainer1 = styled(RuleEditingContainer)`
  position: static;
`;

export const TableEditContainer1 = styled(TableEditContainer)`
  overflow-x: hidden !important;
  table {
    tbody {
      tr {
        :nth-last-child(2) {
          td {
            :first-child {
              background: linear-gradient(
                90deg,
                rgba(81, 166, 190, 1) 0%,
                rgba(137, 136, 215, 1) 50%,
                rgba(188, 97, 246, 1) 100%
              );
              color: #ffffff;
              > div {
                color: #fff;
              }
            }
          }
        }
      }
    }
  }
`;

export const InsertPageWrapper = styled.div`
  width: 100%;
  .pageLayout {
    display: flex;
    margin: 20px auto;
    padding: 0px 15px;
    width: 794px;
    flex-direction: column;
    .top-tools {
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
      transition: 0.2s all;
      top: 0px;
      padding: 4px 4px 4px 0px;
      font-weight: 600;
      color: rgba(14, 19, 24, 0.45);
      width: 794px;
    }
  }
`;

export const HorPopover = styled.div`
  display: flex;
  column-gap: 8px;
  .ant-btn {
    padding: 0px 6px;
    .anticon {
      font-size: 20px;
    }
  }
`;
